// TODO: Добавтить аналитику в https://jira.cian.tech/browse/CD-225650

export const trackJournalSaleClick = () => {};
export const trackJournalRentClick = () => {};
export const trackJournalAdvicesClick = () => {};
export const trackJournalDocumentsClick = () => {};
